export type Platform = 'ios' | 'android' | 'web' | 'unknown';
